import { ChangeEvent } from "react";
import { RaRecord, SelectInput, SelectInputProps } from "react-admin";
import { useFormContext } from "react-hook-form";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { getSitePowerBounds } from "../../utils";

interface CustomSelectInputProps extends SelectInputProps {
  onChange?: (event: ChangeEvent<HTMLInputElement> | RaRecord) => void;
}

const FALLBACK_NOMINAL_POWER_MW: Partial<Record<SiteContryEnum, number>> = {
  [SiteContryEnum.Finland]: 1.25,
  [SiteContryEnum.France]: 1.1,
};

export const CustomSelectCountryInput: React.FC<CustomSelectInputProps> = (props: CustomSelectInputProps) => {
  const { onChange, ...rest } = props;
  const { setValue, getValues } = useFormContext();

  const handleChange = (event: ChangeEvent<HTMLInputElement> | RaRecord) => {
    // Keep the default React Admin behavior
    onChange && onChange(event);

    // Reset the dependent fields
    setValue("dso", "");
    setValue("site_operator", "");
    setValue("supplier", "");
    const country = event.target.value as SiteContryEnum;
    const powerBounds = getSitePowerBounds(getValues("nominal_power") ?? FALLBACK_NOMINAL_POWER_MW[country]);
    if (powerBounds) {
      setValue("min_power_mw", powerBounds.min_power_mw);
      setValue("max_power_mw", powerBounds.max_power_mw);
    }
  };

  return <SelectInput {...rest} onChange={handleChange} />;
};
